(function () {
  /**
   * @ngdoc service/provider
   * @name jilNotifications
   * @description defines service to manage the jil notifications resource
   */
  angular.module('app.core.api.jil').provider('jilNotifications', provider);

  let url;

  /* @ngInject */
  function provider() {
    this.configure = configure;
    this.$get = $get;

    ////////////

    function configure(config) {
      url = `${config.url}/v2/notifications`;
    }

    /* @ngInject */
    function $get($resource) {
      const service = {
        notifications: getNotificationsResource(),
      };

      return service;

      ///////////

      function getNotificationsResource() {
        return $resource(url);
      }
    }
  }
})();
